import { QueryFunction, useQuery } from 'react-query';
import {
    getMonthlyReportsByUser,
    GetMonthlyReportsByUserParams,
    GetPeriodReportQueries,
    getPeriodReports,
    getReportById,
    getReports,
    GetReportsQueries,
    PeriodReport,
    Report,
    UserWithReports,
} from '../../services/apiSLTP/dailyReports/reports';

type UseReportsQueryOptions = {
    queries?: GetReportsQueries;
};

const getReportsQuery: QueryFunction<Report[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseReportsQueryOptions];
    const { queries } = options;

    const response = await getReports(queries);
    return response.data;
};

export const useReportsQuery = (options: UseReportsQueryOptions) => {
    return useQuery(['reports', options], getReportsQuery);
};

type UseReportByIdQueryOptions = {
    reportId: string;
};

const getReportByIdQuery: QueryFunction<Report> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseReportByIdQueryOptions];
    const { reportId } = options;

    const response = await getReportById(reportId);
    return response.data;
};

export const useReportByIdQuery = (options: UseReportByIdQueryOptions) => {
    return useQuery(['report', options], getReportByIdQuery, {
        enabled: !!options.reportId,
    });
};

type UsePeriodReportsQueryOptions = {
    queries: GetPeriodReportQueries;
};

const getPeriodReportsQuery: QueryFunction<PeriodReport[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UsePeriodReportsQueryOptions];
    const { queries } = options;

    const response = await getPeriodReports(queries);
    return response.data;
};

export const usePeriodReportsQuery = (options: UsePeriodReportsQueryOptions) => {
    return useQuery(['period reports', options], getPeriodReportsQuery);
};

type UseMonthlyReportsByUserQueryOptions = {
    params: GetMonthlyReportsByUserParams;
    enabled?: boolean;
};

const getMonthlyReportsByUserQuery: QueryFunction<UserWithReports[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseMonthlyReportsByUserQueryOptions];
    const { params } = options;

    const response = await getMonthlyReportsByUser(params);
    return response.data;
};

export const useMonthlyReportsByUserQuery = (options: UseMonthlyReportsByUserQueryOptions) => {
    return useQuery(['monthly reports by user', options], getMonthlyReportsByUserQuery, {
        enabled: options.enabled !== false && !!options.params.date,
    });
};
